import React, { useContext } from 'react';
import T from 'prop-types';
import cx from 'classnames';
import { times } from 'lodash-es';

import Skeleton from '../../../../components/Skeleton';
import AppIcon from '../../../../components/AppIcon';
import QuickViewContext from '../../../../components/QuickView/QuickViewContext';

const emptyArray = [];

const AppsLine = ({
  apps = emptyArray,
  settings,
  iconSize = 32,
  placeholderLimit = 8,
  allowQV,
}) => {
  const { onAppQuickViewOpen } = useContext(QuickViewContext);

  // Don't show section if no apps are loaded or error occurred
  if ((settings.loaded && !apps.length) || settings.error) {
    return null;
  }

  const handleAppClick = (app) => {
    if (allowQV && app.ref_no != null && `${app.ref_no}` !== '') {
      onAppQuickViewOpen(app);
    }
  };

  return (
    <div className="apps-line">
      {settings.pending
        ? times(placeholderLimit, (n) => <Skeleton key={n} width={iconSize} height={iconSize} />)
        : apps.map((app) => (
            <div
              key={app.ref_no}
              className={cx('apps-line__icon-wrapper ignore-onclickoutside', {
                'cursor-pointer': allowQV,
              })}
              onClick={() => handleAppClick(app)}
            >
              <AppIcon
                url={app.icon_url}
                store={app.store}
                size={iconSize}
                alt={app.nickname}
                withBorder
              />
            </div>
          ))}
    </div>
  );
};

AppsLine.propTypes = {
  apps: T.array,
  settings: T.shape({
    pending: T.bool,
    loaded: T.bool,
    error: T.bool,
  }).isRequired,
  iconSize: T.number,
  placeholderLimit: T.number,
  allowQV: T.bool.isRequired,
};

export default AppsLine;
